// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/hcqadmin/HCQ-Application/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: '.umi__plugin-layout__Layout' */'/home/hcqadmin/HCQ-Application/src/.umi/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/~demos/:uuid",
        "layout": false,
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'../dumi/layout'), loading: LoadingComponent})],
        "component": (props) => React.createElement(
        dynamic({
          loader: async () => {
            const { default: getDemoRenderArgs } = await import(/* webpackChunkName: 'dumi_demos' */ '/home/hcqadmin/HCQ-Application/node_modules/@umijs/preset-dumi/lib/plugins/features/demo/getDemoRenderArgs');
            const { default: Previewer } = await import(/* webpackChunkName: 'dumi_demos' */ 'dumi-theme-default/es/builtins/Previewer.js');
            const { usePrefersColor, context } = await import(/* webpackChunkName: 'dumi_demos' */ 'dumi/theme');

            return props => {
              
      const { demos } = React.useContext(context);
      const renderArgs = getDemoRenderArgs(props, demos);

      // for listen prefers-color-schema media change in demo single route
      usePrefersColor();

      switch (renderArgs.length) {
        case 1:
          // render demo directly
          return renderArgs[0];

        case 2:
          // render demo with previewer
          return React.createElement(
            Previewer,
            renderArgs[0],
            renderArgs[1],
          );

        default:
          return `Demo ${props.match.params.uuid} not found :(`;
      }
    
            }
          }
        }), props)
      },
      {
        "path": "/_demos/:uuid",
        "redirect": "/~demos/:uuid"
      },
      {
        "__dumiRoot": true,
        "layout": false,
        "path": "/~docs",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'../dumi/layout'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/hcqadmin/HCQ-Application/node_modules/dumi-theme-default/es/layout.js'), loading: LoadingComponent})],
        "routes": [
          {
            "path": "/~docs",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'README.md' */'/home/hcqadmin/HCQ-Application/README.md'), loading: LoadingComponent}),
            "exact": true,
            "meta": {
              "locale": "en-US",
              "order": null,
              "filePath": "README.md",
              "updatedTime": 1659595856000,
              "slugs": [
                {
                  "depth": 1,
                  "value": "Home Care Quote",
                  "heading": "home-care-quote"
                },
                {
                  "depth": 2,
                  "value": "Built With",
                  "heading": "built-with"
                },
                {
                  "depth": 2,
                  "value": "Required Environment",
                  "heading": "required-environment"
                },
                {
                  "depth": 2,
                  "value": "Install & Start",
                  "heading": "install--start"
                },
                {
                  "depth": 3,
                  "value": "Start developement project",
                  "heading": "start-developement-project"
                },
                {
                  "depth": 3,
                  "value": "Build production project",
                  "heading": "build-production-project"
                },
                {
                  "depth": 2,
                  "value": "More",
                  "heading": "more"
                }
              ],
              "title": "Home Care Quote"
            },
            "title": "Home Care Quote"
          }
        ],
        "title": "home-care-quote",
        "component": (props) => props.children
      },
      {
        "path": "/forbidden",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__403' */'/home/hcqadmin/HCQ-Application/src/pages/403'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/oops",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__500' */'/home/hcqadmin/HCQ-Application/src/pages/500'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/400",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__400' */'/home/hcqadmin/HCQ-Application/src/pages/400'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/quota-exceeded",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuotaExceeded' */'/home/hcqadmin/HCQ-Application/src/pages/QuotaExceeded'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/quota-expired",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuotaExpired' */'/home/hcqadmin/HCQ-Application/src/pages/QuotaExpired'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/quote-invalid",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuoteInvalid' */'/home/hcqadmin/HCQ-Application/src/pages/QuoteInvalid'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/:clientType/:quoteCode",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/hcqadmin/HCQ-Application/src/pages/client/Layout'), loading: LoadingComponent})],
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__client' */'/home/hcqadmin/HCQ-Application/src/pages/client'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/:clientType/",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/hcqadmin/HCQ-Application/src/pages/client/Layout'), loading: LoadingComponent})],
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__client' */'/home/hcqadmin/HCQ-Application/src/pages/client'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/index.html",
        "redirect": "/undefined",
        "exact": true
      },
      {
        "path": "/",
        "redirect": "/undefined",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/hcqadmin/HCQ-Application/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
